<div>
  @let data = $data();
  <kendo-chip kendoPopoverAnchor [popover]="myPopover">
    @if (data) {
      Last Modified By: {{ data.last_modified_by_user.full_name }}
    } @else {
      <kendo-skeleton class="skeleton banner-text header-text" width="10rem" />
    }
  </kendo-chip>
  <kendo-popover #myPopover [callout]="true" [offset]="0">
    <ng-template kendoPopoverBodyTemplate>
      @if (data) {
        <dl class="horizontal-list">
          <dt>Created By</dt>
          <dd>{{ data.created_by_user.full_name }}</dd>

          <dt>Created At</dt>
          <dd>{{ data.created_dt | dateTimezone }}</dd>

          <dt>Last Modified By</dt>
          <dd>{{ data.last_modified_by_user.full_name }}</dd>

          <dt>Last Modified At</dt>
          <dd>{{ data.last_modified_dt | dateTimezone }}</dd>
        </dl>
      } @else {
        <kendo-loader type="infinite-spinner" />
      }
    </ng-template>
  </kendo-popover>
</div>
